<template>
  <div>
    <b-modal
      id="modal-stock-bin"
      centered
      hide-footer
      :title="modalTitle"
      size="xl"
      @hide="isShow = false"
    >
      <!-- Table Container Card -->
      <b-card no-body class="mb-0">
        <div class="m-1">
          <b-row>
            <b-col>
              <label>{{ $t("general.entries") }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block ml-50 mr-1"
              />
            </b-col>
          </b-row>
        </div>
        <div>
          <n-table
            @sort-changed="sortChanged"
            :fields="fields"
            :items="items"
            :busy="loading"
            :current-page="params.page"
            :per-page="$store.state.pagination.perPage"
            :total="total"
            :type="permissionType"
          >
            <template #cell(stockLocation)="data">
              <span v-if="data.item.stockLocation">
                {{ data.item.stockLocation.name }}
              </span>
            </template>
            <template #cell(availableQuantity)="data">
              <span v-if="data.item.availableItem">
                {{ data.item.availableItem.quantity }}
              </span>
            </template>
            <template #cell(actions)="data">
              <div class="text-nowrap">
                <b-button
                  v-b-tooltip.hover
                  :title="$t('general.stock')"
                  variant="primary"
                  pill
                  size="sm"
                  v-if="$can('update', 'stock')"
                  @click="stockInOut(data.item)"
                >
                  <feather-icon icon="PackageIcon" />
                </b-button>
              </div>
            </template>
          </n-table>
          <n-pagination
            ref="pagination"
            class="mt-2"
            :total="total"
            :per-page="$store.state.pagination.perPage"
            :page="params.page"
            @change="list"
          ></n-pagination>
        </div>
      </b-card>
    </b-modal>
    <stock-modal ref="stockInOutModal" @success="refresh()"></stock-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormGroup,
  BInputGroup,
  BAvatar,
  BBadge,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Repository from "@/repositories/RepositoryFactory";
import NPagination from "@/components/NPagination";
import NSearchContainer from "@/components/NSearchContainer";
import NSearchInput from "@/components/NSearchInput";
import NButtonDelete from "@/components/NButtonDelete";
import NTable from "@/components/NTable";
import TableFields from "./tableFields";
import StockModal from "@/views/stock/stockModal/Modal.vue";

const StockBinRepository = Repository.get("stockBin");

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BAvatar,
    NPagination,
    NSearchContainer,
    NSearchInput,
    NButtonDelete,
    NTable,
    vSelect,
    BFormGroup,
    BInputGroup,
    BBadge,
    StockModal,
  },
  watch: {
    perPage(value) {
      this.list();
    },
  },
  computed: {
    perPage: {
      get() {
        return this.$store.state.pagination.perPage;
      },
      set(value) {
        this.$store.commit("pagination/SET_PER_PAGE", value);
      },
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      total: 0,
      perPageOptions: this.$store.state.pagination.perPageOptions,
      modalTitle: "",
      params: {
        page: 1,
        order: "",
        sort: "",
        search: "",
        itemId: "",
      },
    };
  },
  methods: {
    refresh() {
      this.$emit("refresh");
      this.getData();
    },
    show(item) {
      this.modalTitle = this.$t("general.stockOfItem", {
        item: `${item.name} (${item.itemCode})`,
      });

      this.params.itemId = item.id;
      this.$bvModal.show("modal-stock-bin");
      this.isShow = true;
      this.list();
    },
    hide() {
      this.params = {
        page: 1,
        order: "",
        sort: "",
        search: "",
        itemId: "",
      };
      this.isShow = false;
      this.$bvModal.hide("modal-stock-bin");
    },
    list(page = 1) {
      this.params.page = page;
      this.getData();
    },
    sortChanged(sortBy, sortDirection) {
      this.params.order = sortBy;
      this.params.sort = sortDirection;
      this.getData();
    },
    getData() {
      if (!this.params.itemId) {
        return;
      }
      this.loading = true;
      const params = {
        ...this.params,
        queries: [
          {
            searchby: "item_id",
            searchoperator: "=",
            search: this.params.itemId,
          },
        ],
      };
      StockBinRepository.index(params)
        .then((response) => {
          const data = response.data.data;
          this.items = [...data.list];
          this.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    stockInOut(item) {
      this.$refs.stockInOutModal.show(item.id, item?.availableItem?.itemId);
    },
  },
  setup() {
    const fields = TableFields;
    const permissionType = "stock-bin";

    return {
      fields,
      permissionType,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
